<template>
	<div class="c-wrap c-wrap_short">
		<div class="b_card-item">
			<p class="b_section-title" v-html="title"></p>
			<div v-if="renderComponent" class="b_card-wrp">
				<template v-for="item in list" :key="item.id">
					<b-card :card-data="item" />
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import BCard from './BCard'

export default {
	name: 'SectionBCard',
	components: {
		BCard,
	},
	props: {
		jsonData: {
			type: Array,
			default: [],
		},
	},
	data() {
		return {
			renderComponent: true,
			apiUrl: '/api/external/supportprograms/',
			title: 'Программы с господдержкой для населения',
			list: [
				// {
				// 	id: 'psm',
				// 	img: '/static/dist/v2/img/mortgage/rounded/pref-mortgage.jpg',
				// 	title: 'Льготная ипотека',
				// 	desc: 'Ипотека с господдержкой для всех граждан РФ',
				// 	links: [
				// 		{
				// 			href: 'https://domrfbank.ru/mortgage/programs/mortgage-gos/',
				// 			text: 'Подать заявку',
				// 			hint: 'Переход на сайт Банка ДОМ.РФ',
				// 		},
				// 		{
				// 			href: 'https://xn--h1alcedd.xn--d1aqf.xn--p1ai/instructions/kak-vzyat-ipoteku-s-gospodderzhkoj-po-stavke-6-5/',
				// 			text: 'Как взять ипотеку?',
				// 		},
				// 	],
				// },
				{
					id: 'sip',
					img: '/static/dist/v2/img/mortgage/rounded/family-mortgage.jpg',
					title: 'Семейная ипотека',
					desc: 'Ипотека с господдержкой для семей с детьми',
					links: [
						{
							href: 'https://domrfbank.ru/mortgage/programs/family-mortgage/',
							text: 'Подать заявку',
							hint: 'Переход на сайт Банка ДОМ.РФ',
						},
						{
							href: 'https://xn--h1alcedd.xn--d1aqf.xn--p1ai/instructions/semeinaya-ipoteka/',
							text: 'Как взять ипотеку?',
						},
					],
				},
				{
					id: 'itm',
					img: '/static/dist/v2/img/mortgage/rounded/it-mortgage.jpg',
					title: 'Ипотека для IT-специалиста',
					desc: 'Ипотека с господдержкой для сотрудников IT-сферы',
					links: [
						{
							href: 'https://domrfbank.ru/mortgage/programs/mortgage-it/',
							text: 'Подать заявку',
							hint: 'Переход на сайт Банка ДОМ.РФ',
						},
						{
							href: 'https://xn--h1alcedd.xn--d1aqf.xn--p1ai/instructions/usloviya-programmy-lgotnoy-ipoteki-dlya-it-spetsialistov/',
							text: 'Как взять ипотеку?',
						},
					],
				},
				{
					id: 'dfo',
					img: '/static/dist/v2/img/mortgage/rounded/dv-mortgage.jpg',
					title: 'Дальневосточная и\u00A0Арктическая\u00A0ипотека',
					desc: 'Ипотека на\u00A0территории Дальневосточного\u00A0ФО и\u00A0Арктической зоны\u00A0РФ',
					links: [
						{
							href: 'https://domrfbank.ru/mortgage/programs/far-east/',
							text: 'Подать заявку',
							hint: 'Переход на сайт Банка ДОМ.РФ',
						},
						{
							href: 'https://xn--h1alcedd.xn--d1aqf.xn--p1ai/instructions/ipoteka_dfo/',
							text: 'Как взять ипотеку?',
						},
					],
				},
				{
					img: '/static/dist/v2/img/mortgage/rounded/450-mortgage.jpg',
					title: '450 тысяч на ипотеку',
					desc: 'Погашение ипотечного кредита многодетных родителей',
					links: [
						{
							href: 'https://xn--h1alcedd.xn--d1aqf.xn--p1ai/instructions/pomoshh-mnogodetnym-semyam-v-pogashenii-ipoteki/',
							text: 'Как оформить выплату?',
						},
					],
				},
			],
		}
	},
	methods: {
		forceRender() {
			this.renderComponent = false
			this.$nextTick(() => (this.renderComponent = true))
		},
	},
	created() {
		axios({
			method: 'get',
			url: this.apiUrl,
		}).then(response => {
			this.list.forEach((el, i) => {
				this.list[i] = {
					...el,
					apiData: response.data.data.items[el.id],
					jsonData: this.jsonData.filter(item => item.id === el.id)[0],
				}
			})

			this.forceRender()
		})
	},
}
</script>
